import { useEffect, useState } from 'react';

/**
 * Settles a fast-changing value (keystrokes) into one value that only updates
 * after `delayMs` of quiet. Server-searched pickers key their query on the
 * debounced term so a typed name costs one request instead of one per character.
 *
 * The debounced value is *seeded* with the initial value, so the first render
 * already carries it — an empty initial search term fetches the first page
 * immediately rather than after a delay.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
